import CookieConsent from "react-cookie-consent";
import { useSelector } from "react-redux";

const CookieConsentHook = () => {

  const dir = useSelector(({ theme }) => theme.direction);
    
  return (
    <CookieConsent
      location="bottom"
      buttonText={dir === 'rtl' ? 'قبول جميع ملفات التعريف': 'Accept all Cookies'}
      cookieName="user-ip"
      style={{ background: "var(--main-color)", paddingBlock: '1.5rem', fontSize: "18px", fontWeight: '500', zIndex: '99999' }}
      buttonStyle={{ background: "var(--second-color)", color: "var(--white-color)", fontSize: "14px", padding: '0.75rem', border: 'none', borderRadius: '0.75rem', fontWeight: '600' }}
      expires={365}  // 365 days 
    >
        {dir === 'rtl' ?
          'يستخدم هذا الموقع ملفات التعريف لتحسين تجربة المستخدم.'
          :
          'This website uses cookies to enhance the user experience.'
        }
    </CookieConsent>
  )
}

export default CookieConsentHook